export default __webpack_public_path__ + "static/media/Double_Bow_Thruster_Transversal.c85bf24d.png";